module.exports = __webpack_public_path__ + "img/wholesaleIcon7.ca7f0b10.png";